export default {"src":"/_next/static/media/fruit-icon.49f5cd8f.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};